import { UiColors } from "../../../../config/ui/colors";

export const EVOLUTION_OF_ENERGY_CONSUMPTION_AND_ENERGY_PRICES_CHART_DATA_KEYS = [
	{
		name: "householdsEnergyConsumption",
		translation: "Households energy consumption",
		color: UiColors.charts.primary,
	},
	{
		name: "privateConsumption",
		translation: "Private consumption",
		color: UiColors.charts.secondary,
	},
	{
		name: "averageEnergyPrices",
		translation: "Average energy prices",
		color: UiColors.charts.tertiary,
	},
];